import styled from 'styled-components'

export const InputSearch = styled.input`
  appearance: none;
  background-color: ${({ theme }) => theme.bg3};
  border: 1px solid transparent;
  border-radius: ${({ theme }) => theme.BORDER_RADIUS.small};
  color: ${({ theme }) => theme.text2};
  outline: none;
  padding: 0.5rem 0.8rem;
  transition: ${({ theme }) => theme.TRANSITION.fast};

  &:hover {
    background-color: ${({ theme }) => theme.bg4};
  }

  &:focus {
    border-color: ${({ theme }) => theme.purple1};
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: none;
  `}
`

export const MobileInputSearch = styled(InputSearch)`
  display: none;
  margin-top: 30px;
  width: 100%;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: block;
  `};
`
